import addressChange from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/addressChange.js';
import allegationsChange from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/allegationsChange.js';
import complaintDateChange from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/complaintDateChange.js';
import complaintDateValidation from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/complaintDateValidation.js';
import roleChange from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/roleChange.js';
import submit from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/submit.js';
import syncStore from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/syncStore.js';
import toggleNotification from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/toggleNotification.js';
import upload from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/upload.js';
import workDateChange from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/workDateChange.js';
import workDateValidation from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions/workDateValidation.js';

export default {
    addressChange,
    allegationsChange,
    complaintDateChange,
    complaintDateValidation,
    roleChange,
    submit,
    syncStore,
    toggleNotification,
    upload,
    workDateChange,
    workDateValidation,
};